module.exports = __webpack_public_path__ + "static/imgRight-5e1aeefeab359cb6a1c061981cbeb20a.png";